import * as React from 'react';
import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {BI_SCHEMA} from '../../services/biLogger/biEvents';
import {useBiLogger} from '../BiProvider/withBiLogger';
import {GetSubtitle} from '../GetSubtitle';
import {Button} from '../ui/Button/Button';
import styles from './ContinuePurchase.scss';
import {IOuter} from './ContinuePurchase.types';

function useOnPurchaseContinue(onBuyClick, biLogger, currency, price, entityType) {
  return useCallback(() => {
    onBuyClick();

    biLogger.log(BI_SCHEMA.player.downloadPage.continue.clicked, {
      isSuccess: true,
      currency,
      price: Math.floor(price * 10000),
      errorMsg: '',
      minPrice: undefined,
      type: entityType,
    });
  }, [currency, price, onBuyClick, biLogger, entityType]);
}

export const ContinuePurchaseComponent: React.FunctionComponent<IOuter> = ({
  entityType,
  price,
  currency,
  onBuyClick,
}) => {
  const {t} = useTranslation();
  const biLogger = useBiLogger();

  const onPurchaseContinue = useOnPurchaseContinue(onBuyClick, biLogger, currency, price, entityType);

  return (
    <div className={styles.continuePurchase} data-hook="buyPage">
      <div className={styles.continueButton}>
        <GetSubtitle price={price} currency={currency} entityType={entityType} />
        <Button className={styles.buyButton} dataHook="continue-button" onClick={onPurchaseContinue}>
          {t('mgw.purchaseContinue')}
        </Button>
      </div>
    </div>
  );
};

ContinuePurchaseComponent.displayName = 'ContinuePurchase';
